export const formatUnicorn = function (str, args = {}) {
  if (arguments.length) {
    for (const key in args) {
      // @ts-expect-error js code error
      str = str.replace(new RegExp('\\{' + key + '\\}', 'gi'), args[key])
    }
  }

  return str
}